import React, { Component, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Container, Row, Col } from "shards-react";
import { Map } from 'immutable';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {Tooltip, IconButton} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { practiceListActions } from "../core/practice-lists";
import InternacionDetalleModal from "../components/internaciones/internacion-detalle-modal";

import { orderListActions, getCurrentOrderList, getOrdersForCurrentOrderList, Filters } from "../core/orders-lists";
import OrdersSearchBar from "../components/orders/search-bar";
import { DEFAULT_PER_PAGE } from "../core/constants";
import { url_query } from '../core/helper';
import { api } from "../core/api/api-service";
import LoadingIndicator from "../components/common/loading-indicator";

const style_button = {
    fontSize: 18
}

const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

const css_loading = {
    "position": "absolute",
    "width": "100%",
    "height": "100%",
    // "transform": 'scale(.4)',
    "top": "50%",
    "backgroundColor": "#ffffff",
}

const EstatusIcon = ({ row }) => {
  const classes = useStylesBootstrap();

  let icon = 'fa fa-check-circle'
  let class_name="text-secondary"
  let tooltip_text = "Cerrada"

  if (row.estado === 'A'){
    icon = 'fa fa-check-circle'
    class_name="text-info"
    tooltip_text = "Asignada"
  }
  else if (row.estado === 'PA'){
    icon = 'fa fa-check'
    class_name="text-success"
    tooltip_text = "Parcialmente Asignada"
  }
  else if (row.estado === 'R'){
    icon = 'fa fa-download'
    class_name="text-secondary"
    tooltip_text = "Recibido"
  } 
  else if(row.estado == 'C') {
    icon = 'fa fa-check-circle color-red'
    class_name = "text-secondary"
    let date_formate_baja = moment(new Date(row.fecha_baja)).format('DD/MM/YYYY')
    let infoBaja = [`Estado: Dada de baja`, `Fecha de baja: ${date_formate_baja || ''}`, `Comentario: ${row.motivo_baja || ''}`]
    tooltip_text = infoBaja.join('\n')
  }

  return (
    <div className={ `m-0 p-0 btn ${class_name}` } style={{ 'fontSize':'18px' }} >
      <Tooltip arrow={row.estado == 'C' ? false : true} title={<div style={{ 'whiteSpace': 'pre-line' }}>{tooltip_text}</div>} classes={classes}  placement="top">
      <i className={`${icon}`}></i>
      </Tooltip>
    </div>
  )
};

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_page: 1,
      show_popup_detail: false,
      current_item: null,
      pdfsPending: [],
    }

    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.openLinkOrderPDF = this.openLinkOrderPDF.bind(this);

  }

  handleRowClick(e, row, rowIndex){
    this.handleShowModal(row.id)
  }

  handleShowModal( orderId ){

    this.props.loadPractices(new Map({
      orderId: orderId,
      sessionId: this.props.user.sessionId

    }))

    this.setState({
      show_popup_detail: true,
      current_item: orderId
    });

  }

  handleCloseModal () {

    this.setState({
      show_popup_detail: false,
      current_item: null
    });


   }

  handleDownload(data,e){
    e.preventDefault();
    return false;

  }

  handleFilters(e, filters){
    this.props.loadOrders(filters)
  }

  componentWillMount() {

      const {  authenticated, user, orderlist, orderId} = this.props

      if (authenticated && user.sessionId && !orderlist.isPending)
        this.loadData()

      if ( authenticated && user.sessionId && orderId ){
        this.handleShowModal(orderId)
      }
  }

  componentDidUpdate(oldProps,oldState){

    const { user,  authenticated, orderId } = this.props

    if ( authenticated &&  oldProps.user.sessionId !== user.sessionId ){
      this.loadData()
    }
  }

  loadData(){
    const { user,  loadOrders } = this.props
    loadOrders(new Filters({
      sessionId: user.sessionId
    }))
  }

  openLinkOrderPDF( nroOrden ) {
    const { user } = this.props
    const { pdfsPending } = this.state

    api.getOrderLinkPdf(nroOrden, user.userId).then( res => {
        if( res.link )
            window.open( res.link, "_blank" )
        this.setState({
            pdfsPending: pdfsPending.filter(item => item !== nroOrden)
        })
    })
  }

  render() {
    const { show_popup_detail, current_item, pdfsPending } = this.state
    const { orders, orderlist } = this.props

    if ( !orderlist || (orderlist && orderlist.isPending) )
      return null;

    let internacion = null;
    if (current_item)
      internacion = orders.find( order => current_item === order.id )


    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        //console.log(`click on row with index: ${rowIndex}`);
      },
      onMouseEnter: (e, row, rowIndex) => {
        //console.log(`enter on row with index: ${rowIndex}`);
      }
    };

    const columns = [
        {
          text: 'Pedido',
          dataField: 'nro',
          sort: true,
//          headerStyle: () => {
//            return { width: "6%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Nro. Asociado',
          dataField: 'asociado.nro',
          sort: true,
//          headerStyle: () => {
//            return { width: "10%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Apellido',
          dataField: 'asociado.apellido',
          sort: true,
//          headerStyle: () => {
//            return { width: "9%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Nombre',
          dataField: 'asociado.nombre',
          sort: true,
//          headerStyle: () => {
//            return { width: "11%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Plan',
          dataField: 'plan_nombre',
          sort: true,
//          headerStyle: () => {
//            return { width: "5%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Localidad',
          dataField: 'localidad',
          sort: true,
//          headerStyle: () => {
//            return { width: "15%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Diagnóstico',
          dataField: 'diagnostico',
          sort: true,
//          headerStyle: () => {
//            return { width: "35%" };
//          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {
          text: 'Estado',
          dataField: 'estado',
          sort: true,
          formatter: (cell, row) => <EstatusIcon row={row}/>,
//          headerStyle: () => {
//            return { width: "7%" };
//          },
          headerAlign: 'center',
          align: 'center',
          style: {padding: '6px 0'},
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              e.preventDefault();
              this.handleRowClick(e, row,rowIndex)
              return false;
            }
          }
        },
        {

          text: 'PDF',
          dataField: 'pdf',
          formatter: (cell, row) =>
          <div className="text-center">
                {/* <button onClick={() => { this.setState({pdfsPending: [...pdfsPending, row.nro]}); this.openLinkOrderPDF( row.nro ) }} className="m-0 p-0 btn text-danger btn-sm" style={style_button}> 
                    <i className="far fa-file-pdf"></i>
                </button> */}
                <a href={ row.linkPDF } target="_blank" className="m-0 p-0 btn text-danger btn-sm" style={style_button}> <i className="far fa-file-pdf"></i></a>
          </div>,
//          headerStyle: () => {
//            return { width: "5%" };
//          },
          headerAlign: 'center',
          style: {padding: '6px 0'},
        }
      ];

    return(
      <Container fluid className="main-content-container col-12">
        {this.state.pdfsPending.length > 0 && <div style={css_loading}><LoadingIndicator className="text-center" style={{ "display": "block" }}/></div>}
        <InternacionDetalleModal show={show_popup_detail} internacion={internacion} navigateToPath={this.props.navigateToPath} handleClose={this.handleCloseModal} />

        <ToolkitProvider keyField="id" data={ orders.toJS()  } columns={ columns } search >
          {
            props => (
              <div>
                <OrdersSearchBar { ...props.searchProps }  handleFilters={this.handleFilters} filters={orderlist.filters} />
                <Row>
                  <Col>
                    <BootstrapTable  {...props.baseProps}
                      wrapperClasses="table-fixed-head"
                      bordered={ false }
                      headerClasses="rdt_TableHead"
                      hover
                      condensed
                      pagination={ paginationFactory({
                        hideSizePerPage:true,
                        sizePerPage: DEFAULT_PER_PAGE,
                        hidePageListOnlyOnePage:true
                      }) }
                      rowEvents={ rowEvents }
                      rowStyle={ { cursor: 'pointer' } }
                      loading={ true }
                    />
                  </Col>
                </Row>
              </div>
            )
          }
          </ToolkitProvider>
        </Container>
    )
  }
}
//export default HomePage;


HomePage.propTypes = {
  /**
   * The component's title.
   */
  orderId: PropTypes.number,

};

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  //user_token: url_query().u || null,

  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    orderlist: getCurrentOrderList(state, props),
    orders: getOrdersForCurrentOrderList(state, props),
    orderId: Number(url_query().orden) || null,
    practicaId: Number(url_query().practica) || null,

  };
};

const mapDispatchToProps = {
  loadOrders: orderListActions.loadOrders,
  loadPractices: practiceListActions.loadPractices
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage);
